<template>
 <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.locationGroups')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="card mar-to-15">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
      <div class="card-content">
        <div class="text-right">
          <p class="">
            <button class="btn add" @click.prevent="openEditLocationGroupModal()" :title="$t('general.add') + ' ' + $t('catalogProd.groupType')">
              <img src="/static/img/icons/add.png">
              {{$t('general.add')}}
            </button>
          </p>
        </div>
        <template v-if="groupsData && groupsData.length">
          <div class="demo-collapse">
            <!-- <el-collapse v-model="activeName" accordion> -->
              <draggable
                :list="groupsData"
                :element="'el-collapse'"
                draggable=".handle"
                @end="onEndParent($event, groupsData)"
              >
                <template v-for="(group, idx) in groupsData">
                  <span class="handle">
                    <div class="pull-right disable-chck-location-groups">
                      <div class="col-md-6">
                        <p-checkbox
                          v-model="group.active"
                          :key="group.id"
                          @input="handleActiveGroup(group)"
                        >{{$t('settingsOrdering.enabled')}}</p-checkbox>
                      </div>
                      <div class="col-md-1 mar-lt-15">
                        <!-- <i class="fa fa-pencil" @click="openEditLocationGroupModal(group)"></i> -->
                        <a
                          class="btn btn-icon btn-info mar-rt-10"
                          style="top: -5px;"
                          :title="$t('general.edit')" 
                          @click="openEditLocationGroupModal(group)">
                          <i class="ti-pencil"></i>
                        </a>
                      </div>
                    </div>
                    <el-collapse-item :title="group.name" :name="group.name + '_' + group.id" :key="group.name + '_' + group.id" class="locationGroups">
                      <template v-if="group.children && group.children.length">
                        <draggable
                          :list="group.children"
                          :element="'el-collapse'"
                          draggable=".handle" 
                          @end="onEndChild($event, group.children)">
                          <template v-for="newphew in group.children">
                            <location-group-section 
                              class="handle"
                              :name="newphew.name + '_' + newphew.id"
                              :groupsDataProp="newphew"
                              :groupToBeDeletedProp="groupToBeDeleted"
                              :groupToBeAddedProp="groupToBeAdded"
                              :groupToBeEditedProp="groupToBeEdited"
                              @open-modal="openEditLocationGroupModal($event)"
                            ></location-group-section>
                          </template>
                        </draggable>
                      </template>
                      <template v-else>
                        <div class="pull-left status-line pad-to-10 order-buttons resize-method overflow-container">
                          <template v-for="(loc, id) in group.location_ids">
                            <button class="btn btn-status-margin tablet-overflow ">
                              {{loc.name}}
                            </button>
                          </template> 
                        </div>
                      </template>
                    </el-collapse-item>
                  </span>
                </template>
              </draggable>
            <!-- </el-collapse> -->
          </div>
        </template>
        <template v-else>
          <h3>{{$t('settingLocationGroups.noData')}}</h3>
        </template>
      </div>
    </div>
    <add-edit-modal
      :openModal="openModal"
      :editData="editGroup"
      @new-group="handleNewLocationGroup($event)"
      @edit-group="editLocationsGroup($event)"
      @delete-group="deleteLocationsGroup($event)"
    ></add-edit-modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import LocationGroupSection from './LocationGroupSection.vue'
  import AddEditModal from './AddEditModal.vue'
  import draggable from 'vuedraggable'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  export default {
    components: {
      LocationGroupSection,
      [Input.name]: Input,
      AddEditModal,
      // GeneralTopBar,
      PPagination,
      draggable,
      PSwitch,
      swal
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isLocationGroups: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isLocationGroups () {
        if (this.isLocationGroups) {
          this.getData()
        }
      }
    },
    data () {
      return {
        loading: true,
        tableColumns: [
          {
            prop: 'name',
            label: 'Name',
            // label: this.$t('settingUsers.fn'),
            minWidth: 100
          },
          {
            prop: 'description',
            label: 'Description',
            // label: this.$t('settingUsers.ln'),
            minWidth: 100
          }
        ],
        model: [{
          id: null,
          company_id: null,
          active: true,
          name: '',
          description: '',
          image: '',
          sort_order: null
        }],
        groupsData: {},
        activeName: '',
        groupValidations: {
          group_name: {
            required: true
          },
          group_display: {
            required: true
          }
        },
        editGroup: null,
        openModal: false,
        groupToBeDeleted: null,
        groupToBeAdded: null,
        groupToBeEdited: null
      }
    },
    methods: {
      handleNewLocationGroup (newGroup) {
        let newData = []
        if (!newGroup.parent_id) {
          newGroup.children = []
          newData = [...this.groupsData, newGroup]
          Vue.set(this, 'groupsData', newData)
          return
        }
        if (newGroup.parent_id) {
          let parent = this.findGroupById(this.groupsData, newGroup.parent_id)
          if (parent) {
            let index = this.groupsData.indexOf(parent)
            if (index !== -1 && this.groupsData[index].children && !this.groupsData[index].children.includes(newGroup)) {
              newData = [...this.groupsData[index].children, newGroup]
              Vue.set(this.groupsData[index], 'children', newData)
            }
          } else {
            Vue.set(this, 'groupToBeAdded', newGroup)
          }
        }
      },
      editLocationsGroup (group) {
        if (group.parent_id) {
          this.updateData(group)
        } else {
          this.updateDataChild(group)
          return
        }
        Vue.set(this, 'groupToBeEdited', group)
      },
      deleteLocationsGroup (deletedGroup) {
        let filteredData = []
        if (deletedGroup.hasOwnProperty('children')) {
          this.handleChildrenOfDeletedGroup(deletedGroup.children)
        }
        if (deletedGroup.parent_id) {
          let parent = {}
          parent = this.groupsData.filter(element => {
            return element.id === deletedGroup.parent_id
          })
          if (parent && parent.length === 1) {
            filteredData = parent[0].children.filter(child => {
              return child.id !== deletedGroup.id
            })
            let index = this.groupsData.indexOf(parent[0])
            Vue.set(this.groupsData[index], 'children', [])
            this.$nextTick(function () {
              Vue.set(this.groupsData[index], 'children', filteredData)
            })
            return
          }
        }
        if (this.groupsData.includes(deletedGroup)) {
          filteredData = this.groupsData.filter(element => {
            return element.id !== deletedGroup.id
          })
          Vue.set(this, 'groupsData', filteredData)
          return
        }
        Vue.set(this, 'groupToBeDeleted', deletedGroup)
      },
      updateData (group) {
        let parent = this.findGroupById(this.groupsData, group.parent_id)
        if (parent) {
          let parentIndex = this.groupsData.indexOf(parent)
          if (parentIndex !== -1) {
            let beforeEditGroup = this.findGroupById(this.groupsData[parentIndex].children, group.id)
            let childIndex = this.groupsData[parentIndex].children.indexOf(beforeEditGroup)
            if (childIndex !== -1) {
              Vue.set(this.groupsData[parentIndex].children[childIndex], 'image', group.image)
            }
          }
        }
      },
      updateDataChild (group) {
        let beforeEditGroup = this.findGroupById(this.groupsData, group.id)
        let index = this.groupsData.indexOf(beforeEditGroup)
        if (index !== -1) {
          Vue.set(this.groupsData[index], 'image', group.image)
        }
      },
      findGroupById (haystack, groupId) {
        let beforeEditGroup = haystack.filter(element => {
          return element.id === groupId
        })
        beforeEditGroup = beforeEditGroup.pop()
        return beforeEditGroup
      },
      openEditLocationGroupModal (group = null) {
        Vue.set(this, 'editGroup', group)
        Vue.set(this, 'openModal', !this.openModal)
      },
      handleActiveGroup (group) {
        let actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${group.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: group.active ? 1 : 0,
              name: group.name,
              id: group.id
            }
            this.apiRequest('/location-groups/' + group.id, 'PUT', data, (response) => {
              if (response.status === true) {
                swal(
                  {
                    title: '',
                    text: this.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {}) // end swal
              } else {
                swal(
                  {
                    title: '',
                    text: this.$t('validations.dataCouldNotBeSaved'),
                    type: 'danger',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {}) // end swal
              }
            })
          }
        }).catch(() => {
          group.active = !group.active
        })
      },
      handleChildrenOfDeletedGroup (children) {
        children.forEach(element => {
          let data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            id: element.id,
            name: element.name,
            parent_id: null,
            active: false
          }
          this.apiRequest('/location-groups/' + element.id, 'PUT', data, (response) => {
            if (response.data) {
              this.groupsData.push(response.data)
            }
          })
        })
      },
      onEndParent (evt, haystack) {
        if (haystack && haystack.length > 1) {
          var idx = evt.newIndex
          let sortOrder = this.calculateNewSortOrder(evt, haystack)
          var id = haystack[idx].id
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          this.updateGroup(data, () => {})
        }
      },
      onEndChild (evt, haystack) {
        if (haystack && haystack.length > 1) {
          var idx = evt.newIndex
          let sortOrder = this.calculateNewSortOrder(evt, haystack)
          var id = haystack[idx].id
          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          this.updateGroup(data, () => {
            let parent = this.findGroupById(this.groupsData, haystack[idx].parent_id)
            let index = this.groupsData.indexOf(parent)
            let copy = this.groupsData[index].children
            Vue.set(this.groupsData[index], 'children', [])
            this.$nextTick(function () {
              Vue.set(this.groupsData[index], 'children', copy)
            })
          })
        }
      },
      updateGroup (requestData, callback) {
        this.apiRequest('/location-groups/' + requestData.id, 'PUT', requestData, (response) => {
          if (response.status) {
            callback()
          }
        })
      },
      calculateNewSortOrder (evt, haystack) {
        var idx = evt.newIndex
        var after, before, sortOrder
        if (idx === 0) {
          // console.warn('first')
          before = 0
          after = haystack[idx + 1].sort_order ? haystack[idx + 1].sort_order : 1
        } else if ((idx + 1) === haystack.length) {
          // console.warn('last')
          before = haystack[idx - 1].sort_order
          after = parseFloat(before) + 1
        } else {
          // console.warn('middle')
          before = haystack[idx - 1].sort_order - (haystack[idx - 1].sort_order * 0.1)
          after = haystack[idx + 1].sort_order - (haystack[idx + 1].sort_order * 0.1)
        }
        sortOrder = (parseFloat(before) + parseFloat(after)) / 2
        return sortOrder
      },
      getData () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/locations-groups-index-admin', 'GET', data, (response) => {
          if (response.status === true) {
            Vue.set(this, 'groupsData', response.data)
            this.$nextTick(function () {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
.pencil-icon {
  padding: 20px 0px 0px;
}

.disable-chck-location-groups{
	padding: 0px;
  position: relative;
  top: 20px;
  padding-top: 10px;
  padding-right: 10px;
  /* position: absolute;
  right: 50px; */
}
div.el-collapse span:first-of-type div.disable-chck-location-groups {
  padding-top: 0px;
} 

.checkbox {
  margin: 0px;
}
.el-collapse-item__wrap {
  width: 100%;
}

i.fa {
  width: 35px;
  cursor: pointer;
}
.el-collapse-item.locationGroups {
    padding: 5px 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/LocationGroups/LocationGroups.vue